import { render, staticRenderFns } from "./topicParty.vue?vue&type=template&id=166b679c&scoped=true&"
import script from "./topicParty.vue?vue&type=script&lang=js&"
export * from "./topicParty.vue?vue&type=script&lang=js&"
import style0 from "./topicParty.vue?vue&type=style&index=0&id=166b679c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166b679c",
  null
  
)

export default component.exports